// Package Imports
import Keycloak from 'keycloak-js';

// Project Imports
import {
  REACT_APP_KEYCLOAK_URL,
  REACT_APP_KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_CLIENT_ID,
} from 'config';

const keycloak = new Keycloak({
  url: REACT_APP_KEYCLOAK_URL,
  realm: REACT_APP_KEYCLOAK_REALM || '',
  clientId: REACT_APP_KEYCLOAK_CLIENT_ID || '',
});

export default keycloak;
